import { type AssetClassCategoryEnum } from "@fartherfinance/frontend/api/Investment/types";

import { AssetClassCategory } from "../reducer/Types";
import { assertUnreachable } from "@src/utils/assertUnreachable";

const getAssetClassCategoryEnumFromLabel = (
  label: AssetClassCategory
): AssetClassCategoryEnum => {
  switch (label) {
    case "Equity":
      return "Equity";
    case "Fixed Income":
      return "FixedIncome";
    case "Cash Equivalents":
      return "CashEquivalents";
    case "Other":
      return "Other";
    default:
      return assertUnreachable(label);
  }
};

export default getAssetClassCategoryEnumFromLabel;
